import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// Fix for Leaflet default icon issues
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png'
});
// Custom icons for different location types
const createCustomIcon = color => {
  return L.divIcon({
    className: 'custom-div-icon',
    html: `<div style="background-color: ${color}; width: 12px; height: 12px; border-radius: 50%; border: 2px solid white;"></div>`,
    iconSize: [12, 12],
    iconAnchor: [6, 6]
  });
};
export const JobLocationsMap = ({
  locations
}) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  useEffect(() => {
    // Initialize map if it doesn't exist
    if (!mapInstanceRef.current && mapRef.current) {
      mapInstanceRef.current = L.map(mapRef.current).setView([40.7608, -111.891], 11);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(mapInstanceRef.current);
    }
    // Return cleanup function
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);
  useEffect(() => {
    // Add markers for locations
    if (mapInstanceRef.current) {
      // Clear existing markers
      mapInstanceRef.current.eachLayer(layer => {
        if (layer instanceof L.Marker) {
          mapInstanceRef.current.removeLayer(layer);
        }
      });
      // Add markers for each location
      locations.forEach(location => {
        let icon;
        switch (location.usageType) {
          case 'load-dump':
            icon = createCustomIcon('#EAB308'); // yellow-500
            break;
          case 'load':
            icon = createCustomIcon('#3B82F6'); // blue-500
            break;
          case 'dump':
            icon = createCustomIcon('#8B5CF6'); // purple-500
            break;
          default:
            icon = createCustomIcon('#10B981');
          // green-500
        }
        const marker = L.marker([location.lat, location.lng], {
          icon
        }).addTo(mapInstanceRef.current).bindPopup(`<b>${location.name}</b><br>${location.address}`);
        marker.on('mouseover', function () {
          this.openPopup();
        });
      });
    }
  }, [locations]);
  return <div ref={mapRef} className="h-full w-full" data-id="element-122" />;
};